<section>
  <mat-slide-toggle (change)="onToggle()" [(ngModel)]="selected" class="example-margin" />
</section>
